import { t } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';
import { cn } from '@repo/ui/lib/utils';
import { RegisterOrganizationForm } from '@/components/forms/register-organization';

export const SignUp = () => {
  useLocale();

  return (
    <div
      className={cn(
        'flex justify-center gap-x-12',
        'w-screen max-w-screen-2xl px-4 md:px-16 lg:-my-16',
      )}
    >
      <div className="flex min-h-[min(850px,80vh)] w-full max-w-xl flex-col rounded-xl border border-border bg-neutral-100 p-6 dark:bg-background">
        <div className="h-20">
          <h1 className="font-semibold text-xl md:text-2xl">{t('auth.registerNewOrganization')}</h1>
        </div>

        {/* <hr className="-mx-6 my-4" /> */}
        <RegisterOrganizationForm />
      </div>
      {/* <div className="border-border relative hidden flex-1 overflow-hidden rounded-xl border xl:flex">
        <div className="absolute -inset-8 -z-2 backdrop-blur"></div>
      </div> */}
    </div>
  );
};
